export default {
  items: [
    {
      label: 'Team Members',
      href: '/users',
      icon: 'fa-solid fa-users',
      activeUrl: '/users',
      show: (store) => store.canManageUsers
    },
    {
      label: 'White Label Settings',
      href: '/white_label_configurations',
      icon: 'fa-solid fa-tag',
      activeUrl: '/white_label_configurations',
      show: (store) => store.canManageWlc
    },
    {
      label: 'Integrations',
      href: '/integrations',
      icon: 'fa-solid fa-plug',
      activeUrl: '/integrations',
      show: (store) => store.canViewIntegrations
    },
    {
      label: 'API Keys',
      href: '/api_tokens',
      icon: 'fa-solid fa-key',
      activeUrl: '/api_tokens',
      show: (store) => store.canManageApiKeys
    },
    {
      label: 'Webhooks',
      href: '/webhooks',
      icon: 'fa-solid fa-satellite-dish',
      activeUrl: '/webhooks',
      show: (store) => store.canManageApiKeys
    }
  ]
}
